import React from "react";
import { useState, useEffect } from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
// import "./TimecardFollowup.css";
import "../../GlobalCss/SPF/TimecardFollowup.css";
import TimeSheetGrid from "../../Components/TimeCardFollowUpGrid/TimeSheetGrid";
import AutoCrawlSection from "../../Components/TimeCardFollowUpGrid/AutoCrawlSection";
import { Button,Layout,Modal,Select,Table,Card,Upload,Image,Spin,} from "antd";
import { UploadOutlined, InfoCircleOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import axios from "axios";
import * as XLSX from "xlsx";
import { LoadingOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  callTimecardsGrid,
  getAutocrawlData,
  TSCsvDownload,
  downloadXL,
  getClients,
} from "../../Repository/TimecardFollowupRepository";
import { ErrorMessage, SuccessMessage } from "../../Utils/Utils";
import JSZip from "jszip";
import { BaseUrl } from "../../Repository/BaseRepository";
const { Header, Content } = Layout;

const TimesheetTeam = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [loader, setLoader] = useState(false);
  const [statusData, setStatusData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [autocrawlData, setAutoCrawlData] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [csvLoader, setCsvLoader] = useState(false);
  const [frequency, setFrequency] = useState("");
  const [vms, setVms] = useState("");
  const [chooseClient, setChooseClient] = useState([]);
  const [missingClients, setMissingClients] = useState();
  const [missingClientsCount, setMissingClientsCount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clients, setClients] = useState([]);
  const jwtToken = Cookies.get("jwt_token");
  const [fileList, setFileList] = useState([]);
 
  useEffect(() => {
    callGrid();
    callClientsList();
    getMissingClients();
  }, []);
  const callGrid = async () => {
    try {
      setTableLoader(true);
      const res = await callTimecardsGrid();
      if (res != null) {
        setStatusData(res);
        setOriginalData(res);
      }
      setTableLoader(false);
    } catch {
      setTableLoader(false);
    }
  };
  const callClientsList = async () => {
    try {
      const res = await getClients();
      if (res !== null && res.length > 0) {
        setClients(res);
      }
    } catch {
      // ErrorMessage("Cannot able to get clients data, please try again")
    }
  };
  const openPopup = async () => {
    try {
      setLoader(true);
      setShowErrorMsg(false);
      const res = await getAutocrawlData();
      if (res !== null) {
        if (res.BatchLabel === "Auto Crawl Process Not Completed") {
          setShowErrorMsg(true);
        } else {
          setAutoCrawlData(res);
          setShowPopup(true);
        }
      }
      setLoader(false);
    } catch {
      setLoader(false);
    }
  };
  const closePopup = () => {
    setShowPopup(false);
  };
  const dwldTSGrid = async () => {
    try {
      setCsvLoader(true);
      const resp = await TSCsvDownload(originalData);
      if (resp === "downloaded") {
        SuccessMessage("Downloaded successfully !!");
      }
      setCsvLoader(false);
    } catch {
      setCsvLoader(false);
    }
  };
  const changeDownload = async (prop) => {
    const res = await downloadXL(prop, originalData);
  };
  const getDataBasedOnFreq = async (e, prop) => {
    if (prop !== undefined) {
      setFrequency(prop.key);
      if (vms !== "" && chooseClient.length > 0) {
        const filteredData = statusData.filter(
          (item) =>
            item.Frequency === prop.key &&
            item.Portal === vms &&
            chooseClient.some((propItem) => propItem.key === item.Client)
        );
        setOriginalData(filteredData);
      } else if (vms === "" && chooseClient.length > 0) {
        const filteredData = statusData.filter(
          (item) =>
            item.Frequency === prop.key &&
            chooseClient.some((propItem) => propItem.key === item.Client)
        );
        setOriginalData(filteredData);
      } else if (vms !== "" && chooseClient.length === 0) {
        const filteredData = statusData.filter(
          (item) => item.Frequency === prop.key && item.Portal === vms
        );
        setOriginalData(filteredData);
      } else if (vms === "" && chooseClient.length === 0) {
        const filteredData = statusData.filter(
          (item) => item.Frequency === prop.key
        );
        setOriginalData(filteredData);
      }
    } else {
      setFrequency("");
      if (vms !== "" && chooseClient.length > 0) {
        const filteredData = statusData.filter(
          (item) =>
            item.Portal === vms &&
            chooseClient.some((propItem) => propItem.key === item.Client)
        );
        setOriginalData(filteredData);
      } else if (vms === "" && chooseClient.length > 0) {
        const filteredData = statusData.filter((item) =>
          chooseClient.some((propItem) => propItem.key === item.Client)
        );
        setOriginalData(filteredData);
      } else if (vms !== "" && chooseClient.length === 0) {
        const filteredData = statusData.filter((item) => item.Portal === vms);
        setOriginalData(filteredData);
      } else if (vms === "" && chooseClient.length === 0) {
        setOriginalData(statusData);
      } else {
        setOriginalData(statusData);
      }
    }
  };
  const getDataBasedOnVMS = async (e, prop) => {
    if (prop !== undefined) {
      setVms(prop.key);
      if (frequency !== "" && chooseClient.length > 0) {
        const filteredData = statusData.filter(
          (item) =>
            item.Portal === prop.key &&
            item.Frequency === frequency &&
            chooseClient.some((propItem) => propItem.key === item.Client)
        );
        setOriginalData(filteredData);
      } else if (frequency === "" && chooseClient.length > 0) {
        const filteredData = statusData.filter(
          (item) =>
            item.Portal === prop.key &&
            chooseClient.some((propItem) => propItem.key === item.Client)
        );
        setOriginalData(filteredData);
      } else if (frequency !== "" && chooseClient.length === 0) {
        const filteredData = statusData.filter(
          (item) => item.Portal === prop.key && item.Frequency === frequency
        );
        setOriginalData(filteredData);
      } else if (frequency === "" && chooseClient.length === 0) {
        const filteredData = statusData.filter(
          (item) => item.Portal === prop.key
        );
        setOriginalData(filteredData);
      }
    } else {
      setVms("");
      if (frequency !== "" && chooseClient.length > 0) {
        const filteredData = statusData.filter(
          (item) =>
            item.Frequency === frequency &&
            chooseClient.some((propItem) => propItem.key === item.Client)
        );
        setOriginalData(filteredData);
      } else if (frequency === "" && chooseClient.length > 0) {
        const filteredData = statusData.filter((item) =>
          chooseClient.some((propItem) => propItem.key === item.Client)
        );
        setOriginalData(filteredData);
      } else if (frequency !== "" && chooseClient.length === 0) {
        const filteredData = statusData.filter(
          (item) => item.Frequency === frequency
        );
        setOriginalData(filteredData);
      } else if (frequency === "" && chooseClient.length === 0) {
        setOriginalData(statusData);
      } else {
        setOriginalData(statusData);
      }
    }
  };
  const getDataBasedOnClient = async (e, prop) => {
    if (prop.length > 0) {
      setChooseClient(prop);
      if (frequency !== "" && vms !== "") {
        const filteredData = statusData.filter(
          (item) =>
            item.Portal === vms &&
            item.Frequency === frequency &&
            prop.some((propItem) => propItem.key === item.Client)
        );
        setOriginalData(filteredData);
      } else if (frequency === "" && vms !== "") {
        const filteredData = statusData.filter(
          (item) =>
            item.Portal === vms &&
            prop.some((propItem) => propItem.key === item.Client)
        );
        setOriginalData(filteredData);
      } else if (frequency !== "" && vms === "") {
        const filteredData = statusData.filter(
          (item) =>
            item.Frequency === frequency &&
            prop.some((propItem) => propItem.key === item.Client)
        );
        setOriginalData(filteredData);
      } else if (frequency === "" && vms === "") {
        const filteredData = statusData.filter((item) =>
          prop.some((propItem) => propItem.key === item.Client)
        );
        setOriginalData(filteredData);
      }
    } else {
      setChooseClient([]);
      if (frequency !== "" && vms !== "") {
        const filteredData = statusData.filter(
          (item) => item.Portal === vms && item.Frequency === frequency
        );
        setOriginalData(filteredData);
      } else if (frequency === "" && vms !== "") {
        const filteredData = statusData.filter((item) => item.Portal === vms);
        setOriginalData(filteredData);
      } else if (frequency !== "" && vms === "") {
        const filteredData = statusData.filter(
          (item) => item.Frequency === frequency
        );
        setOriginalData(filteredData);
      } else if (frequency === "" && vms === "") {
        setOriginalData(statusData);
      } else {
        setOriginalData(statusData);
      }
    }
  };
  const getMissingClients = async () => {
    try {
      const url = `${process.env.REACT_APP_BASE_URL}MissingClients/timecard/employees/discrepency`;
      const config = {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      };
      const response = await axios.get(url, config);
      setMissingClients(response.data);
      setMissingClientsCount(response.data.length);
      //   console.log(response.data);
    } catch (error) {
      console.error("Error fetching missing clients:", error);
    }
  };
  // useEffect(() => {
  //   getMissingClients();
  // }, []);
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(missingClients);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "MissingEmployees");
    XLSX.writeFile(wb, "MissingEmployees.xlsx");
  };
  const columns = [
    {
      title: "File Number",
      dataIndex: "filenumber",
      key: "filenumber",
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Middle Name",
      dataIndex: "middleName",
      key: "middleName",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Client",
      dataIndex: "client",
      key: "client",
    },
  ];

  const vmsOptions = [
    "Agile",
    "Fieldglass",
    "Beeline",
    "Prowand",
    "Green Resources",
    "IQN",
    "Econometrix",
    "Leoforce",
    "Simplify",
    "Vndly",
    "Workforce Logiq",
  ];

  

  return (
    <>
      <Layout
        style={{
          backgroundColor: "white",
          height: "100vh",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <SideNavBar />
        <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
          <Header className="preview-header-class">
            <Navbar />
          </Header>
          <Content style={{ overflow: "auto", height: "100%" }}>
            <div className="timesheet-first-div">
              <div className="name-autocrawl1">
                <div className="timesheet-title">
                  <span>Timesheet Team</span>
                  <div className="line-class"></div>
                </div>
                <div className="notifictaion">
                  <Button
                    type="submit"
                    className="autocrawl-button"
                    onClick={openPopup}
                    loading={loader}
                  >
                    Auto Crawl
                  </Button>
                  {showErrorMsg ? (
                    <div className="status-para">! Autocrawl is processing</div>
                  ) : null}
                </div>
                
              </div>

              <div className="ts-dwld-class">
                <div className="missing-client">
                  <p style={{ marginRight: "15px" }}>Missing Employees</p>
                  <p style={{ color: "#3B52DF" }}>
                    {missingClientsCount}
                    <InfoCircleOutlined
                      onClick={openModal}
                      style={{
                        marginLeft: "10px",
                        cursor: "pointer",
                      }}
                    />
                  </p>
                  <Modal
                    title={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ textAlign: "center", color: "#3B52DF" }}>
                          Missing Employees
                        </div>
                        <Button type="primary" onClick={exportToExcel}>
                          Export to Excel
                        </Button>
                      </div>
                    }
                    open={isModalOpen}
                    onCancel={closeModal}
                    footer={null}
                    width={800}
                    bodyStyle={{
                      maxHeight: "440px",
                      overflowY: "scroll",
                    }}
                  >
                    <div className="failed-clients-sub-list">
                      <Table
                        dataSource={missingClients}
                        className="missingemp-table"
                        columns={columns}
                        pagination={false}
                        scroll={{ y: 370 }}
                        rowKey={(record) => record.filenumber}
                      />
                    </div>
                  </Modal>
                </div>
                <div className="ts-drop">
                  <Select
                    onSelect={changeDownload}
                    className="ts-drowpdowns"
                    placeholder={
                      <span
                        className="placeholder-span"
                        style={{ color: "rgba(59, 82, 223, 1)" }}
                      >
                        Download as
                      </span>
                    }
                    style={{ width: 210, marginLeft: 15 }}
                    options={[
                      {
                        value: "one",
                        label:
                          "Action Required - Missing/Rejected/Pending Timecards",
                      },
                      {
                        value: "two",
                        label:
                          "Report - Missing/Rejected/Submitted Timecards - A Reqs",
                      },
                      {
                        value: "three",
                        label: "REPORT - Missing/Rejected Timecards - C Reqs",
                      },
                      {
                        value: "four",
                        label: "REPORT - ST/OT/DT Timecard Errors",
                      },
                    ]}
                  />
                </div>
                <div>
                  <Button
                    loading={csvLoader}
                    type="submit"
                    className="tsdwnld-button"
                    onClick={dwldTSGrid}
                  >
                    Download .CSV
                    <UploadOutlined
                      style={{ transform: "rotate(180deg)", fontSize: 16 }}
                    />
                  </Button>
                </div>
              </div>
              <Modal
                open={showPopup}
                className="modal"
                footer={false}
                width={400}
                onOk={openPopup}
                onCancel={closePopup}
              >
                <div style={{ minHeight: 605 }}>
                  <AutoCrawlSection
                    statusdata={statusData}
                    sendtoParent={setStatusData}
                    autocrawl={autocrawlData}
                    frequency={frequency}
                    originalData={originalData}
                    setOriginalData={setOriginalData}
                    vms={vms}
                  />
                </div>
              </Modal>
            </div>
            <div className="timesheet-second-div">
              {/* <label className="label-timesheet">VMS</label> */}
              <Select
                className="ts-drowpdowns"
                placeholder={
                  <span
                    className="placeholder-span"
                    style={{ color: "rgba(59, 82, 223, 1)" }}
                  >
                    Select VMS
                  </span>
                }
                style={{ width: 150, marginLeft: 15 }}
                size="medium"
                allowClear
                onChange={(e, item) => getDataBasedOnVMS(e, item)}
              >
                {vmsOptions
                  ? vmsOptions.map((item) => {
                      return <Select.Option key={item}>{item}</Select.Option>;
                    })
                  : null}
              </Select>
              {/* <label className="label-timesheet">Payroll Type</label> */}
              <Select
                className="ts-drowpdowns"
                placeholder={
                  <span
                    className="placeholder-span"
                    style={{ color: "rgba(59, 82, 223, 1)" }}
                  >
                    Select Payroll Type
                  </span>
                }
                style={{ width: 180, marginLeft: 15 }}
                allowClear
                onChange={(e, key) => getDataBasedOnFreq(e, key)}
              >
                <Select.Option key={"Weekly"}>Weekly</Select.Option>
                <Select.Option key={"Bi-Weekly"}>Bi-Weekly</Select.Option>
              </Select>
              <Select
                mode="multiple"
                className="ts-drowpdowns"
                placeholder={
                  <span
                    className="placeholder-span"
                    style={{ color: "rgba(59, 82, 223, 1)" }}
                  >
                    Select Client
                  </span>
                }
                style={{ width: 180, marginLeft: 15 }}
                size="medium"
                allowClear
                maxTagCount="responsive"
                // value={clients}
                onChange={(e, item) => getDataBasedOnClient(e, item)}
              >
                {clients
                  ? clients.map((item) => {
                      return (
                        <Select.Option key={item.Client}>
                          {item.Client}
                        </Select.Option>
                      );
                    })
                  : null}
              </Select>
            </div>

            <TimeSheetGrid
              statusdata={statusData}
              sendtoParent={setStatusData}
              vms={vms}
              tableLoader={tableLoader}
              setTableLoader={setTableLoader}
              frequency={frequency}
              originalData={originalData}
              setOriginalData={setOriginalData}
            />
          </Content>
        </Layout>
      </Layout>
    </>
  );
};
export default TimesheetTeam;
